import React from 'react'
import { connect } from 'react-redux'
import OrganizationForm from './organizationForm'
import { createOrganization } from '../../actions/organizationActions'
import Breadcrumb from '../../components/Breadcrumb'

const OrganizationNewComponent = ({ dispatch, history }) => {
  const onSubmit = (values) =>
    dispatch(createOrganization(values)).then((org) =>
      history.push(`/organizations/${org.id}`)
    )

  return (
    <>
      <Breadcrumb
        levels={[
          { label: 'Organizations', path: '/organizations' },
          { label: 'New', path: '' },
        ]}
      />
      <div className="index index__drive-america">
        <h1 className="index-table__header">New Organization</h1>
        <OrganizationForm onSubmit={onSubmit} />
      </div>
    </>
  )
}

export default connect()(OrganizationNewComponent)
